var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewAppsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.4 2.41715C3.08572 2.41715 1.18286 4.32 1.18286 6.63429V12.6C1.18286 14.9143 3.08572 16.8171 5.4 16.8171H11.4171C13.7314 16.8171 15.6343 14.9143 15.6343 12.6V9.61715C15.6343 9.30858 15.8914 9 16.2514 9C16.56 9 16.8686 9.25715 16.8686 9.61715V12.6C16.8686 15.5829 14.4514 18 11.4686 18H5.4C2.41714 18 0 15.5829 0 12.6V6.58286C0 3.6 2.41714 1.18286 5.4 1.18286H8.38286C8.69143 1.18286 9 1.44 9 1.8C9 2.16 8.74286 2.41715 8.38286 2.41715H5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 3.6C18 5.60571 16.4057 7.2 14.4 7.2C12.3943 7.2 10.8 5.60571 10.8 3.6C10.8 1.59429 12.3943 0 14.4 0C16.4057 0 18 1.59429 18 3.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewAppsIcon);
export default __webpack_public_path__ + "static/media/NewAppsIcon.93efe88d7afb6bd59a7c1998b9ba9214.svg";
export { ForwardRef as ReactComponent };